import a from "./_baseForOwn.js";
import e from "./_createBaseEach.js";
var r = e(a);
const t = r;
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseEach.js
// module id = 1469
// module chunks = 67